/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-19 16:33:37
 * @LastEditTime: 2025-05-19 18:55:53
 * @LastEditors: jia-wink 1847949884@qq.com
 */
let env = process.env.NODE_ENV;

// const apiHost = env === 'development' ? '//112.124.40.205:9579/api/' : '//ydapi.linghit.com/api/';
const apiHost = '/api/';
const liveapiHost = '/v1/';
const liveapiHostV2 = '/v2/';

/*
 * 当前的环境判断
 * 'development' 开发环境
 * 'production'  生产环境
 */

const wxConfig = {
	appid: location.href.indexOf('sandbox-yd') !== -1 ? 'wx716e2b98e8a3409d' : 'wxea2b42aebf4f7468'
	// appid:env === 'development' ? 'wx716e2b98e8a3409d' : 'wxea2b42aebf4f7468'
};
let apiPath = {
	/* 公共服务接口start */
	getJsSdk: `${apiHost}comm/wx/jssdk`,
	logInfo: `${apiHost}comm/log`, // 用户行为统计
	isPopBoot: `${apiHost}comm/pop_boot`, // 新手弹窗
	getNoticeNums: `${apiHost}comm/notice`, //获取聊天信息条数
	login: `${apiHost}login/lingji`, // 灵机登录接口
	shareStatic: `${apiHost}comm/share_static`, // 分享统计接口
	logStep: `${apiHost}guide/log`, // 记录新手引导步骤
	clickCoupon: `${apiHost}comm/click_coupon`, // 新用户是否点击了优惠券
	/* 公共服务接口end */

	/* 首页接口start */
	banner: `${apiHost}comm/banner`, // banner图
	indexAsks: `${apiHost}ask/list`, // 首页问题列表
	highService: `${apiHost}high_service/category`, // 首页高价服务分类
	highServiceV1: `${liveapiHost}wds/category`, // 首页高价服务分类v1
	askMoneyRank: `${apiHost}teacher/rank_list`, //获取快速回复榜列表
	evaluateRank: `${apiHost}evaluate/rank_list`, //获取评价榜列表
	// answerRank:`${apiHost}ask/money_rank`, //获取人气打赏榜列表
	answerRank: `${apiHost}reward/teacher_rank`, //获取人气打赏榜列表
	getIsReadlyFocus: `${apiHost}comm/wx/subscribe`, // 获取用户是否已经关注公众号
	readText: `${apiHost}coupon/info`, // 首页发券获取优惠券信息
	getUserCommentList: `${liveapiHost}wds/teacher/user_comment_list`, // 用户心声
	recommendTeacher: `${apiHost}usercate/recommend/teacher`, // 问名师列表

	/* 连线 */
	createShorturl: `${liveapiHost}wechat/mini_program/generate/shorturl`, // 生成短链
	vocTeacherInfo: `${liveapiHost}voc/teacher/info`, // 获取老师语音通话信息
	/* 首页接口end */

	/* 高价服务的老师列表start */
	highServiceAnswer: `${apiHost}high_service/teacher`,
	highServiceAnswerV1: `${liveapiHost}high/service/area/teacher`,
	/* 高价服务的老师列表end */

	/* 我要问页面start */
	answersList: `${apiHost}usercate/teacher`, //答主列表页面
	/* 我要问页面end */

	/*咨询室start*/
	getChatList: `${apiHost}ask/consultant/list`, //获取聊天信息列表
	getConsultantStatus: `${apiHost}ask/consultant/status`, //获取服务状态及评价内容
	consultantEvaluate: `${apiHost}evaluate/consultant`, //服务内容评价
	uploadVideo: `${apiHost}comm/upload/video`, // 上传聊天录音接口
	/*咨询室end*/

	/*我的优惠券*/
	couponUseful: `${apiHost}coupon/usable`, // 优惠券可以使用信息列表
	couponExpired: `${apiHost}coupon/expired`, // 已过期的优惠券列表
	couponUsedV1: `${liveapiHost}coupon/used`, // 优惠券已使用信息列表
	couponUsefulV1: `${liveapiHost}coupon/usable`, // 优惠券可以使用信息列表
	couponExpiredV1: `${liveapiHost}coupon/expired`, // 已过期的优惠券列表

	/*我听页面*/
	toutingAsks: `${apiHost}ask/touting`, // 获取已偷听问题列表
	/*课程相关接口*/
	hotClass: `${apiHost}course/hot`, //首页课程列表
	indexClass: `${apiHost}course/home`, //课程首页接口
	teachClass: `${apiHost}course/teacher_special`, //老师首页课程列表
	myCourseList: `${apiHost}user/course`, //我的课程列表
	zhuanlanDetail: `${apiHost}course/special_detail`, //专栏课程详情
	courseList: `${apiHost}course/course_list`, //试看课程列表
	courseDetail: `${apiHost}course/course_detail`, //单个课程详情
	courseOrder: `${apiHost}order/course`, //系列课程下单
	courseSearch: `${apiHost}course/search`, //课程搜索
	courseFree: `${apiHost}order/course_free`, //课程搜索

	/*个人收益列表*/
	moneyList: `${apiHost}account/account_list`,
	/*个人收益金钱*/
	moneyObj: `${apiHost}account/withdraw_info`,
	/*提现接口*/
	drawMoney: `${apiHost}account/withdraw`,
	/*收益须知*/
	syxzMoney: `${apiHost}distribution/income_notice`,

	/* 偷听页面start */
	getPublicAsk: `${apiHost}ask/public_info`, // 获取公开问题
	getAsk: `${apiHost}ask/info`, // 获取问题
	randAsk: `${apiHost}ask/rand_ask`, // 随机一个问题
	touting: `${apiHost}lingji/order_touting`, // 获取用户是否已经支付过该偷听问题

	/* 偷听页面end */
	/*获取免费咨询室的roomId以及fromUid*/
	getRoomId: `${apiHost}free_chat/create_room`,
	freeChatList: `${apiHost}dszx/freechat/list`, // 大师免费咨询列表
	//收益主页偷听信息
	toutingInfo: `${apiHost}touting/info`,
	//收益主页偷听列表
	toutingList: `${apiHost}touting/ask_list`,
	/* 个人中心页面start */
	getPersonal: `${apiHost}user/info`, //个人中心
	asks: `${apiHost}user/asks`, // 获取已问问题列表
	aiAsks: `${liveapiHost}order/alone_pay/order/list`, // 获取已问问题列表
	pauserTeacher: `${apiHost}user/pauser`, // 暂停老师接单
	feedback: `${apiHost}comm/feedback`, // 用户反馈接口
	getCouponNums: `${apiHost}user/coupon_num`, //获取聊天信息条数
	getQrcode: `${apiHost}teacher/qrcode`, //获取二维码

	/* 个人中心页面end */
	/* 个人中心消息中心 */
	myMessages: `${apiHost}message/free_chat/list`,
	myMessagesV2: `${liveapiHostV2}freechat/lists`,
	myPrivate: `${apiHost}free_chat/private_room`,
	delMessages: `${apiHost}message/free_msg/del`,
	updateSetUp: `${apiHost}message/update_setup`,
	getIsPush: `${apiHost}message/setup`,

	/* 打赏页面start */
	getUserRewardList: `${apiHost}reward/user_rank`, // 用户打赏列表
	getAnswerRewardList: `${apiHost}reward/teacher_rank`, // 老师打赏页面
	rewardGetAnswerInfo: `${apiHost}teacher/info`, // 打赏页面获得老师详情
	rewardSuccess: `${apiHost}reward/success`, //打赏成功
	rewardOrder: `${apiHost}lingji/order_reward`, // 打赏页面支付
	rewardTeacher: `${apiHost}order/reward`, // 打赏接口，非lingji
	/* 打赏页面end */

	/* 老师编辑资料页面start */
	getMyInfo: `${apiHost}user/info`, // 获得个人信息
	editMyself: `${apiHost}user/teacher/edit`, // 修改保存个人信息
	/* 老师编辑资料页面end */

	/* 问题详情页面start */
	getAskAgain: `${apiHost}ask/info`, // 获取用户详情问题
	getEvaluate: `${apiHost}evaluate/status`, // 获取评论信息
	recommend: `${apiHost}teacher/recommend`, // 老师推荐接口
	getUserAskReward: `${apiHost}ask/reward_money`, //  打赏页面获得问题回答金额
	addEvaluate: `${apiHost}evaluate/add`, //提交评价接口
	askPress: `${apiHost}ask/press`, // 用户追问问题
	delFile: `${apiHost}ask/del/image`, // 删除图片
	/* 问题详情页面end */

	/* 提问下单页面start */
	answerInfo: `${apiHost}teacher/info`, // 老师的介绍
	// highPriceService:`${apiHost}teacher/serve`, // 获取老师服务
	highPriceService: `${apiHost}teacher/service`, // 获取老师服务
	highPriceServiceV2: `${liveapiHostV2}teacher/serve`, // 获取老师服务v2
	addUserMess: `${apiHost}user/add_public_msg`, // 添加用户信息
	getUserMessList: `${apiHost}user/public_msg`, // 获得用户信息列表
	answered: `${apiHost}teacher/answered_list`, // 老师已回答问题列表
	evaluateList: `${apiHost}teacher/evaluate_list`, // 老师评价列表
	userfollow: `${apiHost}teacher/follow`, //用户关注老师接口
	askOrder: `${apiHost}lingji/order_ask`, //普通问题下单接口
	consultantOrder: `${apiHost}lingji/order_consultant`, // 图文咨询下单接口
	couponInfo: `${apiHost}high_service/coupon`, // 图文咨询获取价格接口
	upload: `${apiHost}ask/upload/image`, // 图片上传接口
	uploadPhoto: `${apiHost}ask/upload/image`, // 上传图片
	delUserMessList: `${apiHost}user/del_public_msg`, //删除用户
	isPayed: `${apiHost}lingji/order_is_pay`, // 判断订单是否已经支付完成了

	/* 提问下单页面end */

	/* 老师回答问题列表start */
	answerMessage: `${apiHost}teacher/info`, // 老师问题的条数
	noAnswerList: `${apiHost}answer/unanswered_list`, // 老师未回答列表
	answeredList: `${apiHost}answer/anwered_list`, // 老师已经回答的问题
	overAnswerList: `${apiHost}answer/over_ask_list`, // 老师已过期列表
	causeAnswerList: `${apiHost}answer/refund_list`, // 老师已拒单列表
	/* 老师回答问题列表end */

	/*老师回答问题详情start*/
	historyAsk: `${apiHost}answer/history`, //追问回答历史API
	askInfo: `${apiHost}ask/info`, // 获取主问题的内容
	pressInfo: `${apiHost}ask/press_info`, // 获取追问问题的内容
	answer: `${apiHost}answer/post`, //上传主问题的答案
	answerPress: `${apiHost}answer/press/post`, // 上传追问问题的答案
	/*老师回答问题详情end*/

	/* 手机注册start */
	isBindPhone: `${apiHost}bind/channel_phone`, // 通过渠道绑定手机
	isOldBindPhone: `${apiHost}bind/channel_phone`, // 旧的绑定手机
	sendCode: `${apiHost}bind/send_code`, // 发送验证码
	verify: `${apiHost}bind/query`, // 绑定手机号码
	prizeList: `${apiHost}bind/prize_list`, // 获取已经领取的优惠券列表
	/* 手机注册end */

	/*老师拒单接口*/
	refundCause: `${apiHost}order/ask_refund`, // 老师拒单

	/* 搜索页面start */
	search: `${apiHost}search/index`, // 获取主问题的内容
	hotSearch: `${apiHost}search/hot_keyword`, // 获取主问题的内容
	searchResult: `${apiHost}search/result`, // 获取主问题的内容
	/* 搜索页面end */

	// 一单多问功能屏蔽
	// randomAnswer:`/index.php/home/apiEntry/api/randomAnswer`, //获取老师接口
	// askMoreOrder:`/index.php/home/apiEntry/api/askMore`, // 一单多问下单

	// newNums:'/index.php/home/apiEntry/api/static', //新手弹框次数

	/* 收入与支出start */
	income: `${apiHost}user/income`, // 收入
	disburse: `${apiHost}user/disburse`, // 支出
	settle: `${apiHost}user/settle`, // 结算
	/* 收入与支出end */

	/* 闪测模块start */
	scHome: `${apiHost}sc/home`, //闪测首页
	scCategory: `${apiHost}sc/cate`, //闪测类别
	scList: `${apiHost}sc/list`, //闪测类别列表
	scDetail: `${apiHost}sc/detail`, //闪测详情
	scComment: `${apiHost}sc/comments`, //闪测列表
	scOrder: `${apiHost}lingji/order_sc`, //闪测下单
	scFeedback: `${apiHost}sc/feedback`, //闪测反馈
	scHotList: `${apiHost}sc/recommend`, //最热闪测列表
	sctoRecommend: `${apiHost}sc/question`, //推荐闪测
	scFreeCoupon: `${apiHost}sc/limited_coupons`, //获取自由问复购优惠券
	scGetCoupon: `${apiHost}sc/receive_limited_coupons`, //领取自由问复购优惠券

	/* 闪测模块end */
	bindUser: `${apiHost}lingji/user/bind`, // 绑定用户

	/*获取用户八字信息	*/
	publicMsg: `${apiHost}user/one_public_msg`, //八字信息
	editMsg: `${apiHost}user/edit_public_msg`, //八字信息

	/* 用户登录 */
	mobileLogin: `${apiHost}login/mobile`, //八字信息
	loginCode: `${apiHost}login/send_code`, //八字信息
	loginSmsCode: `${apiHost}login/sms_code`, //短信加密获取验证码
	loginPublicKey: `${apiHost}comm/setting`, //短信加密public_key

	bindQian: `${apiHost}huangdaxian/bind`,
	qianList: `${apiHost}estimate/order/lists`,
	bindUserOrder: `${apiHost}zx/order/bind/user`,
	couponApi: `${apiHost}coupon/receive`,

	/*节日弹窗活动*/
	frame: `${apiHost}comm/popup_activity`,
	/* 新人体验聊天室列表 */
	newChatRoom: `${apiHost}experience/chat_room`,
	// 握手聊天室
	createHandsRoom: `${apiHost}experience/create_chat_room`,
	// 消息中心
	noticeNews: `${apiHost}notice/news`,
	/*快速提问*/
	quickAsk: `${apiHost}comm/quick`,
	/*快速提问优化*/
	askQuick: `${apiHost}ask/quick`,
	/*快速提问下单接口*/
	quickSubmit: `${apiHost}order/fast/ask_order`,
	/*快速提问下单接口优化*/
	orderQuick: `${apiHost}order/quick`,
	homeRecommend: `${apiHost}comm/home_recommend`, // 首页汇总

	// H5版免登陆
	scRecommend: `${apiHost}sc/home_recommend`, // 闪测推荐弹窗
	isUseCoupon: `${apiHost}coupon/is_use`, // 是否已使用新手优惠券
	// 删除普通问题
	askdel: `${apiHost}user/askdel`,
	// 删除智能咨询师问题
	aiAskDel: `${liveapiHost}order/alone_pay/order/delete`,
	// 支付成功导粉二维码根据channel获取
	getCodeByChannel: `${apiHost}bind/fans_qrcode`,

	//售后
	reminders: `${apiHost}aftersale/reminders`,
	complaintDetail: `${apiHost}aftersale/complaint`,
	agreeAfterSale: `${apiHost}aftersale/agree`,
	interventionAfterSale: `${apiHost}aftersale/intervention`,
	cancelComplaint: `${apiHost}aftersale/complaint/cancel`,
	complaint: `${apiHost}aftersale/complaint`,
	// 帮助中心
	problemList: `${apiHost}helpcenter/problem/list`,
	helpcenterguide: `${apiHost}helpcenter/guide`,
	problem: `${apiHost}helpcenter/problem`,

	getMaxCoupon: `${apiHost}coupon/max_coupon`, // 获取用户面额最大的优惠券
	getBaZiList: `${liveapiHost}user/mess/list`, // 八字列表
	getNewPan: `${liveapiHost}common/single_astrolabe`, // 新星盘信息算法接口
	getHoroscope: `${liveapiHost}common/horoscope`, // 星盘解读接口

	//高级服务获取优惠券
	highServiceCoupon: `${apiHost}high_service/coupon`,
	//优惠券改版同步咨询室接口
	serviceList: `${apiHost}/high_service/service_list`, //优惠券使用高级列表
	vipWelfareCoupon: `${liveapiHostV2}vip/welfare/receive`, // 会员优惠券领取
	//我的关注列表
	commentsTagsList: `${apiHost}teacher/evaluate_tag`,
	//商城接口
	addExperience: `${apiHost}shop/experience/add`, //发布心得
	editExperience: `${apiHost}shop/experience/edit`, //编辑心得
	getExperience: `${apiHost}shop/experience/info`, //获取心得
	myExperience: `${apiHost}user/goods_experience`, //我的心得
	shopCate: `${apiHost}shop/category`, //首页类目
	experList: `${apiHost}shop/experience/list`, //首页心得列表
	deleteExper: `${apiHost}shop/experience/delete`, //删除心得
	goodsRelate: `${apiHost}shop/goods/relate`, //相关商品
	experRelate: `${apiHost}shop/experience/relate`, //相关心得
	goodsList: `${apiHost}shop/goods/list`, //商品列表
	experGoods: `${apiHost}user/user_experience_goods`, //老师发布过的心得
	goodsSearch: `${apiHost}shop/goods/search`, //商品推荐搜索
	sendGoods: `${apiHost}shop/goods/send_goods`, //商品推荐
	shopCommentList: `${apiHost}shop/comment/list`, // 商品心得评论列表
	submitComnent: `${apiHost}shop/comment/make_comment`, //提交心得评论
	experZan: `${apiHost}shop/experience/zan`, //心得点赞
	goodsInfo: `${apiHost}shop/goods/info`, //获取单个商品详情
	userNotList: `${apiHost}shop/comment/user_list`, //用户消息通知
	teacNotList: `${apiHost}shop/comment/teacher_list`, //老师消息通知
	recommended: `${apiHost}shop/goods/recommended`, //历史推荐
	alRead: `${apiHost}shop/comment/is_read`, //评论已读
	shopBanner: `${apiHost}shop/banner`, //商城banner
	shopOrder: `${liveapiHost}shop/user/goods/order`, // 商品订单
	recTeacher: `${liveapiHost}teacher/recommend/other`, // 商品详情页推荐老师
	//我的关注列表
	followList: `${apiHost}user/follow`,
	// 秒杀活动
	getSecKill: `${apiHost}spike/list`, // 当天活动列表
	getSecKillNotice: `${apiHost}spike/notice`,
	secKillSubscription: `${apiHost}spike/subscription`,
	spikeCoupon: `${apiHost}spike/coupon`, // 领优惠券
	spikeScores: `${apiHost}spike/scores`, // 获取贡献值
	spikeAward: `${apiHost}spike/prize`, // 获取山水画
	// 获取微信公众号支付域名
	wxPublicPayUrl: `${apiHost}comm/on_off`,
	// 获取直播列表
	liveList: `${liveapiHost}live/listv3`,
	// 获取客户端下载链接
	getLjdsDownUrl: `${liveapiHost}download/link`,
	// 检查设备号绑定
	deviceCheck: `${apiHost}user/check/device`,
	//动态获取快速提问老师
	quickTeacher: `${apiHost}teacher/quick_teacher`,
	//获取快速提问价格
	quickPrice: `${apiHost}order/quick/price`,
	//新增用户八字标签
	addMessLabel: `${apiHost}user/add_mess_label`,
	// 获取每日运势
	getYunshi: `${apiHost}comm/yunshi/daily`,
	//获取用户八字标签
	getMessLabel: `${apiHost}user/mess_label`,
	//获取最近的咨询室订单
	orderRecently: `${apiHost}order/recently`,
	//设置用户常用八字信息
	defaultMsg: `${apiHost}user/default_public_msg`,
	//删除用户八字信息
	delPubMsg: `${apiHost}user/del_public_msg`,
	//编辑用户八字信息
	editPubMsg: `${apiHost}user/edit_public_msg`,
	// 获取FM列表
	fmList: `${liveapiHost}fm/audio/list`,
	//塔罗

	//获取塔罗牌
	tarotDraw: `${apiHost}tarot/draw`,
	//下单
	taluoOrderAsk: `${apiHost}order/ask`,
	//用户最新一条闪测订单信息
	userScFind: `${apiHost}ask/user/sc_find`,
	//判断是否已关注公众号
	wxSubscribe: `${apiHost}comm/wx/subscribe`,

	// 私密聊天室
	delFreeChatroom: `${liveapiHost}freechat/delete`, // 删除免费聊天室
	consultList: `${liveapiHost}consultant/lists`, // 免费聊天咨询记录
	freeChatTop: `${liveapiHost}freechat/set`, // 置顶免费聊天室
	sendChatroom: `${apiHost}free_chat/send_message`, // 发送消息到免费聊天室

	// 消耗元宝接口
	coinConsume: `${liveapiHost}user/coin/consume`, // 置顶免费聊天室
	// 老师年度盛典
	getTeacherInfo: `${apiHost}user_vote/teacher_index`, // 获取老师信息
	//每日签到start
	checkYunshi: `${apiHost}activity/yunshi/checkInfo`, //运势签到信息
	signYunshi: `${apiHost}activity/yunshi/checkin`, //运势签到
	qrcode: `${apiHost}comm/qrcode`, //获取公众号二维码
	//每日签到end
	getIsPayed: `${apiHost}order/list`, // 查询订单支付状态

	// 2022年度老师盛典 右下角资源位
	getStarTeacher: `${liveapiHostV2}home/adv/star_teacher`,

	addEvaluateConsultant: `${liveapiHost}evaluate/consultant`,

	highServiceDetail: `${apiHost}teacher/service/info`,

	// 闪测订单包购买记录
	scPackagebuyRecord: `${apiHost}order/sc_package/buy_record`,

	// 首页平台老师推荐弹窗
	recStayPop: `${liveapiHostV2}popup/stay`, // 会员优惠券领取

	getUserInfo: `${apiHost}user/info`, // 会员优惠券领取

	returnPop: `${liveapiHost}freechat/return/pop`, // 咨询室返回弹窗
	scOrder: `${apiHost}sc/order`, // 闪测-下单
	newBanner: `${liveapiHost}home/common/adv_resourse`, // 闪测-下单
	yqwSmsH5: `${apiHost}sw/jump_link/yqw_sms_h5`
};

export {apiPath, wxConfig};



// WEBPACK FOOTER //
// ./src/common/js/config.js